module.exports = __webpack_public_path__ + "static/scale-model-of-salem's-riverfront-carousel-in-salem-oregon-a6a7b6793fe72c3664cefdda8a460d7a.png";